import { RRModalModel } from './modal.model';

export class RRModalButtonsModel {
  label: string;
  class?: string;
  return: string;
  closeModal?: boolean;
  openModal?: RRModalModel;
  buttonOrder?: number;
  disabled?: boolean;
}
